import React from 'react';
import AnimatedBackground from '../components/AnimatedBackground';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';


const HomePage = () => {
  return (
    <div className="relative">
      <AnimatedBackground />
      <main className="relative z-10">
        <HeroSection />
        <FeaturesSection />
      </main>
    </div>
  );
};

export default HomePage;
